import { render, staticRenderFns } from "./ClienteManage.vue?vue&type=template&id=b4196dd6&scoped=true"
import script from "./ClienteManage.vue?vue&type=script&lang=js"
export * from "./ClienteManage.vue?vue&type=script&lang=js"
import style0 from "./ClienteManage.vue?vue&type=style&index=0&id=b4196dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4196dd6",
  null
  
)

export default component.exports